import { useTranslate } from "@lobby/ocb-intl";
import type { WarningEventPayload } from "../../lib";
import { Dialog, type IDialogProps } from "../dialog";
import { Icon } from "../icons";

interface IWarningModalProps extends IDialogProps {
  payload: WarningEventPayload;
}

export function WarningModal({ payload }: IWarningModalProps) {
  const { $t } = useTranslate();

  const title = $t({ defaultMessage: "please note" });

  return (
    <Dialog type="warning" closable={false}>
      <Dialog.Title>
        <Icon name="warningSign" className="text-[2.5rem]" />
        <div>{title}</div>
      </Dialog.Title>
      <Dialog.Message>{payload.message}</Dialog.Message>
    </Dialog>
  );
}
